export const AMLS_COMMON = '/common';
export const AMLS_TM_COMMON = '/tm/common';
export const AMLS_TM_IAD = '/tm/iad';
export const AMLS_TM_SAM = '/tm/sam';
export const AMLS_NS_COMMON = '/ns/common';
export const AMLS_NS_IAD = '/ns/iad';
export const AMLS_NS_SAM = '/ns/sam';
export const AMLS_CRS = '';
export const AMLS_CM = '/cm';

export const ROUTE_AMLS_COMMON = '';
export const ROUTE_AMLS_TM_IAD = '';
export const ROUTE_AMLS_TM_SAM = '/app/tm';
export const ROUTE_AMLS_SMART_SCREENING = '/app/smart-screening';
export const ROUTE_AMLS_NS_SAM = '/app/ns';
export const ROUTE_AMLS_CRS = '';

export const TOKEN_ID =
  (localStorage && localStorage.getItem('id_token')) || '';

export const AMLS_COMMON_HTTP_HEADERS = Object.freeze({
  'Content-Type': 'application/json',
  'X-HTTP-Method-Override': 'PUT',
  // Authorization: `${TOKEN_ID}`
  Authorization: `Bearer ${TOKEN_ID}`
});

export const DYNAMIC_PROPERTIES_TAB = 'Dynamic Properties';
export const DYNAMIC_PROPERTIES_DETAILS_PAGE_ID = 'DYNAMIC_PROPERTIES_DETAILS';

export const CURRENT_PIPELINES_TAB = 'Pipelines';
export const CURRENT_PIPELINES_DETAILS_PAGE_ID = 'CURRENT_PIPELINES_DETAILS';

export const CRS_SETTINGS_TAB_MODULE_ID = '8';
export const CRS_SETTING_TAB_SUBMODULE = 'global';
export const CRS_IAD_TAB_MODULE_NAME = 'CRS';

export const NS_SETTINGS_TAB_MODULE_ID = '5';
export const NS_SETTING_TAB_SUBMODULE = 'global';
export const NS_IAD_TAB_MODULE_NAME = 'NS-IAD';

export const TS_SETTINGS_TAB_MODULE_ID = '7';
export const TS_SETTING_TAB_SUBMODULE = 'global';
